import { ListStyleConfigurations } from '../config.type';
import { BorderRadiusKeys } from '../default-constants/global-styling.enum';
import { borderRadius } from './global-theming-table.utils';

export const GLOBAL_LIST_STYLING_CLASS = 'global-list-styling';

const GLOBAL_LIST_SCOPE_SELECTOR = `#web-app .${GLOBAL_LIST_STYLING_CLASS}`;

export function listStyleDefaults(): ListStyleConfigurations {
  return {
    borderRadiusClass: BorderRadiusKeys.NONE,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 16,
    marginLeft: 0,
    marginUnit: 'px',
    paddingTop: 10,
    paddingRight: 10,
    paddingBottom: 10,
    paddingLeft: 10,
    paddingUnit: 'px',
    borderRadiusTopLeft: 5,
    borderRadiusTopRight: 5,
    borderRadiusBottomLeft: 5,
    borderRadiusBottomRight: 5,
    borderRadiusUnit: 'px',
    borderWidth: 1,
    borderColor: 'var(--color-border-color)',
    backgroundColor: 'var(--color-surface)',
    textColor: 'var(--color-on-surface)',
    shadowColor: 'transparent',
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowBlur: 0,
    shadowSpread: 0,
  };
}

// A theme saved before list global styling existed falls back to the defaults, so a newly dropped
// (and therefore linked) list widget is never left unstyled.
export function getListRawCssString(list: ListStyleConfigurations | undefined): string {
  const l = { ...listStyleDefaults(), ...list };
  const declarations = [
    `margin: ${l.marginTop}${l.marginUnit} ${l.marginRight}${l.marginUnit} ${l.marginBottom}${l.marginUnit} ${l.marginLeft}${l.marginUnit};`,
    `padding: ${l.paddingTop}${l.paddingUnit} ${l.paddingRight}${l.paddingUnit} ${l.paddingBottom}${l.paddingUnit} ${l.paddingLeft}${l.paddingUnit};`,
    `border-width: ${l.borderWidth}px;`,
    'border-style: solid;',
    `border-color: ${l.borderColor};`,
    `border-radius: ${borderRadius(l)};`,
    `background-color: ${l.backgroundColor};`,
    `color: ${l.textColor};`,
    `box-shadow: ${l.shadowOffsetX}px ${l.shadowOffsetY}px ${l.shadowBlur}px ${l.shadowSpread}px ${l.shadowColor};`,
  ];
  return `\n${GLOBAL_LIST_SCOPE_SELECTOR} { ${declarations.join(' ')} }\n`;
}
